var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.011 13h-.018c-.056 0-5.634-.011-7.041-.405a2.29 2.29 0 0 1-1.586-1.638A25.3 25.3 0 0 1 0 6.494a25.5 25.5 0 0 1 .375-4.469C.589 1.226 1.19.6 1.964.371 3.332 0 8.757 0 8.987 0h.019c.056 0 5.649.011 7.042.405a2.29 2.29 0 0 1 1.584 1.636c.261 1.479.384 2.98.366 4.482.007 1.497-.12 2.99-.376 4.464a2.3 2.3 0 0 1-1.589 1.635c-1.366.374-6.792.378-7.022.378M7.213 3.716l-.005 5.566L11.895 6.5z"
})));
export default SvgYoutube;